/**
 * resolveBasePath необходим для работы с диплинками
 * В случае, если страница открыта через диплинки
 * возвращаем базовый путь без динамических маршрутов.
 */

export const DYNAMIC_TO_BASE_ROUTES: Record<string, string> = {
  '/passes/[passId]': '/passes',
  '/passes/[passId]/comments': '/passes',
  '/requests/[requestId]': '/requests',
  '/requests/[requestId]/comments': '/requests',
  '/requests/new': '/requests'
}

export const resolveBasePath = (pathname: string): string => {
  return DYNAMIC_TO_BASE_ROUTES[pathname] ?? pathname
}
